<template lang="pug">
  UndraggableRouterLink(
    :to="$tools.getURL(item.get('attributes.path'))"
    :onClick="onClickHandler"
  ).ListItem.ListItem-landscape.ListItem-dark
    .ListItem_catchable()
    .ListItem_wrapper(ref="wrapper")

      p.ListItem_new(v-if="item.get('attributes.tour_is_new')") {{ $t('tour.new') }}
      .ListItem_bg
        AdaptativeImg(:derivatives="item.derivatives" :type="'block'" :fit="true" :name="item.title")

      .ListItem_content
        p.ListItem_type {{ item.tourType }}

        ItemIndex(:index="index")

        h3.ListItem_title {{ item.title }}

        .ListItem_sep

        p.ListItem_footer
          SvgInline(src="hourglass")
          span {{ $t('tour.visit_duration', { min: item.get('attributes.visit_duration') }) }}

</template>

<script>
import ItemIndex from '@/components/common/ItemIndex'
import AdaptativeImg from '@/components/common/AdaptativeImg'
import SvgInline from '@/components/SvgInline'
import mouseParallax from '@/mixins/mouseParallax'
import UndraggableRouterLink from '@/components/common/UndraggableRouterLink'
const {sessionStorage} = window

export default {
  props: ['item', 'index'],
  mixins: [mouseParallax],
  components: {
    ItemIndex,
    AdaptativeImg,
    SvgInline,
    UndraggableRouterLink
  },
  data () {
    return {
      indice: 0.05,
      ratio: 30
    }
  },
  beforeDestroy () {
    // On retirer l'enregistrement du session storage
    // Cela permet que l'enregistrement ne soit utilisé que par la prochaine page !
    sessionStorage.removeItem('tourThumbRect')
  },
  mounted () {
    this.initMouseEvents()
  },
  methods: {
    onClickHandler (e) {
      // On créer une copy du domRect dans un nouvel objet
      // permet du pouvoir le convertir en String et le stocker dans le sessionStorage
      const {top, left, right, bottom, width, height, x, y} = e.currentTarget.getBoundingClientRect()

      // On sauvegarde le rect dans le session storage afin qu'il puisse être utilisé par la prochaine page
      sessionStorage.setItem('tourThumbRect', JSON.stringify({top, left, right, bottom, width, height, x, y}))
    }
  }
}

</script>

<style lang="stylus" scoped>
  .ListItem
    box-sizing: border-box
    &_content
      @media $mq_l
        padding-bottom 60px

    &_title
      padding 0 15%
      font-size 25px

      @media $mq_m
        font-size 38px

      @media $mq_l
        font-size 50px

    &_new

      font-size 14px
      color $beige
      text-transform uppercase
      position absolute
      bottom 15px
      right 15px
      z-index 5
      font-weight 600

      @media $mq_s_only

        font-size 12px

    &_sep
      margin 15px auto

      @media $mq_m
        margin 22px auto

      @media $mq_l
        margin 30px auto

    &_footer
      svg
        width 12px
        vertical-align middle
        margin-right 12px

    &_bg

      picture
        position absolute
        opacity .25
        width 100%
        height 100%

</style>
